const LOAD_TIMEOUT_MS = 10_000

const cache = new Map<string, Promise<HTMLImageElement>>()

// Cached so a retry after a failed completion reuses the decoded picture instead of fetching it again.
export const loadPuzzleImage = (url: string): Promise<HTMLImageElement> => {
  const cached = cache.get(url)
  if (cached) return cached

  const pending = new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    const timeoutId = window.setTimeout(() => {
      reject(new Error("Puzzle image timed out"))
    }, LOAD_TIMEOUT_MS)
    image.decoding = "async"
    image.onload = () => {
      window.clearTimeout(timeoutId)
      void image
        .decode()
        .catch(() => undefined)
        .then(() => {
          resolve(image)
        })
    }
    image.onerror = () => {
      window.clearTimeout(timeoutId)
      reject(new Error("Puzzle image failed to load"))
    }
    image.src = url
  })

  pending.catch(() => {
    cache.delete(url)
  })
  cache.set(url, pending)
  return pending
}
